import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import BaseInputComponent from './BaseInputComponent.vue';
export default {
  extends: BaseInputComponent,
  props: {
    variant: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'md'
    },
    floating: {
      type: Boolean
    }
  },
  computed: {
    selectedItemText() {
      return this.items.find(i => i.value === this.value)?.label ?? this.value;
    }
  },
  data: function () {
    return {
      showMenu: false,
      dropdownID: Math.floor(Math.random() * 9000) + 1000
    };
  },
  methods: {
    HandleItemClick: function (item) {
      if (!item.input) {
        this.value = item.value;
        this.showMenu = false;
      } else {
        this.value = item.value;
      }
    }
  }
};